import React from "react";
import { Button } from "@mui/material";
import ContactsIcon from "@mui/icons-material/Contacts";
import { useMediaQuery } from "@mui/material";

const ImportContactsMobile = ({ onContactsSelected, isMobile, t }) => {

  const handleImport = async () => {
    if (!("contacts" in navigator) || !("select" in navigator.contacts)) {
      alert(
        t("ImportContactsNotSupported") ||
        "L'import des contacts n'est pas disponible sur ce navigateur."
      );
      return;
    }

    try {
      const props = ["name", "tel", "email"];

      const contacts = await navigator.contacts.select(props, {
        multiple: true
      });

      if (!contacts || contacts.length === 0) {
        return;
      }

      const contactsFormates = contacts.map((contact) => {
        const tel = contact.tel?.[0] || "";

        const indicatifMatch = tel.match(/^\+\d+/);
        const indicatif = indicatifMatch ? indicatifMatch[0] : "+33";
        const numero = tel.replace(/^\+\d+/, "");

        return {
          nom: contact.name?.[0] || "",
          indicatif,
          numero,
          mail: contact.email?.[0] || ""
        };
      });

      console.log("📱 Contacts sélectionnés :", contactsFormates);

      if (onContactsSelected) {
        onContactsSelected(contactsFormates);
      }

    } catch (err) {
      if (err?.name !== "AbortError") {
        console.error("❌ Erreur import contacts :", err);
      }
    }
  };

  return (
    <Button
      type="button"
      variant="contained"
      onClick={handleImport}
      startIcon={
        <ContactsIcon sx={{ color: "#fff !important" }} />
      }
      sx={{
        color: "#fff",
        backgroundColor: "#3399FF !important",
        borderColor: "#3399FF",
        marginLeft: 1,
        marginTop: 1,
        fontWeight: "bold",
        fontSize: isMobile ? "0.5rem" : "0.7rem",
        transition: "all 0.3s ease",
        minHeight: "48px",
        paddingX: 3,
        paddingY: 2,
        borderRadius: 1,

        "&:hover": {
          backgroundColor: "#3399FF !important",
          color: "#fff"
        }
      }}
    >
      {t("ImportFromMobile") || "Importer des contacts"}
    </Button>
  );
};

export default ImportContactsMobile;